/**
 * Simple toast notification plugin for Vue.js
 * Provides toast.success, toast.error, toast.warning, and toast.info methods
 */

export default {
  install: (app) => {
    // Create a simple toast function
    const toast = {
      /**
       * Show a success toast message
       * @param {string} message - Message to display
       */
      success(message) {
        console.log('SUCCESS:', message);
        createToast(message, 'success');
      },

      /**
       * Show an error toast message
       * @param {string} message - Message to display
       */
      error(message) {
        console.log('ERROR:', message);
        createToast(message, 'danger');
      },

      /**
       * Show a warning toast message
       * @param {string} message - Message to display
       */
      warning(message) {
        console.log('WARNING:', message);
        createToast(message, 'warning');
      },

      /**
       * Show an info toast message
       * @param {string} message - Message to display
       */
      info(message) {
        console.log('INFO:', message);
        createToast(message, 'info');
      }
    };

    /**
     * Create and display a toast notification
     * @param {string} message - Message to display
     * @param {string} type - Bootstrap alert type (success, danger, warning, info)
     */
    function createToast(message, type) {
      // Create toast container if it doesn't exist
      let toastContainer = document.getElementById('toast-container');
      if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.id = 'toast-container';
        toastContainer.className = 'toast-container position-fixed top-0 start-0 p-3';
        document.body.appendChild(toastContainer);

        // Add some basic styles
        const style = document.createElement('style');
        style.textContent = `
          .toast-container {
            z-index: 9999;
            top: 1rem !important;
            left: 1rem !important;
          }
          .toast {
            margin-bottom: 10px;
            max-width: 350px;
            opacity: 0;
            animation: fadeIn 0.3s ease forwards, fadeOut 0.5s ease 4s forwards;
            box-shadow: 0 4px 8px rgba(0,0,0,0.2);
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes fadeOut {
            from { opacity: 1; transform: translateY(0); }
            to { opacity: 0; transform: translateY(-20px); }
          }
        `;
        document.head.appendChild(style);
      }

      // Create toast element with improved visibility
      const toast = document.createElement('div');
      toast.className = `toast show bg-${type} text-white fw-bold`;
      toast.style.display = 'block'; // Ensure it's visible
      toast.style.padding = '12px';
      toast.style.borderRadius = '4px';
      toast.innerHTML = `
        <div class="toast-body" style="padding: 10px; font-size: 14px;">
          <i class="fas ${type === 'success' ? 'fa-check-circle' : type === 'danger' ? 'fa-exclamation-circle' : type === 'warning' ? 'fa-exclamation-triangle' : 'fa-info-circle'}"></i>
          <span style="margin-left: 8px;">${message}</span>
        </div>
      `;
      toastContainer.appendChild(toast);

      // Remove toast after animation
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 4500);
    }

    // Add to the app as a global property
    app.config.globalProperties.$toast = toast;
  }
}; 